import { render, staticRenderFns } from "./BDTreeNode.vue?vue&type=template&id=06d45492&scoped=true&"
import script from "./BDTreeNode.vue?vue&type=script&lang=js&"
export * from "./BDTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./BDTreeNode.vue?vue&type=style&index=0&id=06d45492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d45492",
  null
  
)

export default component.exports